import { render } from "./LeaveRequests.vue?vue&type=template&id=0ff4e265&scoped=true"
import script from "./LeaveRequests.vue?vue&type=script&lang=js"
export * from "./LeaveRequests.vue?vue&type=script&lang=js"

import "./LeaveRequests.vue?vue&type=style&index=0&id=0ff4e265&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff4e265"]])

export default __exports__